import * as React from 'react';

import { Dialog, Button } from '@blueprintjs/core';

export default class WelcomeDialog extends React.Component {
  state = {
    isOpen: true,
  }

  handleClose = () => {
    this.setState({isOpen: false});
  }

  render() {
    const { isOpen } = this.state;
    return (
      <Dialog isOpen={isOpen} 
        className="WelcomeDialog"
        title="Preview the course"
        onClose={this.handleClose}>

        <div className="bp3-dialog-body">
          <p>The full course already contains over 10 hours of pro-quality 4K videos with subtitles.</p>
        
        <p>And we're shooting more every week.  This preview mode gives you
          an idea of what you get when you buy the course.  </p>

      <p>Lifetime access is a one-time payment of {(window as any).COURSE.price}.
        No subscriptions.  Pay once, unlock everything forever.</p>
    

      <div style={{textAlign: 'center'}}>
      <Button icon="play" text="Watch previews" onClick={this.handleClose} intent="success" large={true} />
      </div>

          <div className="_footer">
            <p>Already bought the course?  
              &nbsp;<a href="/login">Sign in here</a></p>
          </div>
        </div>
      </Dialog>
    )
  }
}
